import React from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
//import Tour from '../components/Tour/index';
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from 'constants/ActionTypes';
import {isIOS, isMobile} from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';

class App extends React.Component {

  render() {
    const {match, drawerType, navigationStyle, horizontalNavPosition} = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }

    return (
      <div className={`app-container ${drawerStyle}`}> 
        {/* <Tour/> */}

        <Sidebar/> 
        <div className="app-main-container">
          <div
            className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
            <TopNav styleName="app-top-header"/>}
            <Header/>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
            <TopNav/>}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                  <Route path={`${match.url}/mainPage`}
                         component={asyncComponent(() => import('./routes/MainPage'))}/>
                                <Route exact path={`${match.url}/`} 
                         component={asyncComponent(() => import('./routes/MainPage'))}/>

   <Route path={`${match.url}/addActivityPage`}
                         component={asyncComponent(() => import('./routes/activity/AddActivityPage'))}/>
   <Route path={`${match.url}/listActivityPage`}
                         component={asyncComponent(() => import('./routes/activity/ListActivityPage'))}/>
                           <Route path={`${match.url}/managementActivityPage`}
                         component={asyncComponent(() => import('./routes/activity/ManagementActivityPage'))}/>

<Route path={`${match.url}/addSubmissionPage/:id`}
                         component={asyncComponent(() => import('./routes/submission/AddSubmissionPage'))}/>


<Route path={`${match.url}/mySubmissionPage`}
                         component={asyncComponent(() => import('./routes/submission/MySubmissionPage'))}/>

<Route path={`${match.url}/manageSubmissionPage/:id`}
                         component={asyncComponent(() => import('./routes/submission/ManageSubmissionPage'))}/>

<Route path={`${match.url}/myRefereePage`}
                         component={asyncComponent(() => import('./routes/referee/MyRefereePage'))}/>
                         
<Route path={`${match.url}/testPage`}
                         component={asyncComponent(() => import('./routes/activity/Test'))}/>
{/* <Route path={`${match.url}/myRefereePastPage`}
                         component={asyncComponent(() => import('./routes/referee/MyRefereePastPage'))}/> */}


<Route path={`${match.url}/submissionReview/:id`}
                         component={asyncComponent(() => import('./routes/referee/ReviewSubmissionPage'))}/>
                       
                <Route path={`${match.url}/401`}component={asyncComponent(() => import('components/Error401'))}/>
                <Route component={asyncComponent(() => import('components/Error404'))}/>
              </Switch>
            </div>
            <Footer/>
          </main>
        </div>
      </div>
    );
  }
}


const mapStateToProps = ({settings}) => {
  const {drawerType, navigationStyle, horizontalNavPosition} = settings;
  return {drawerType, navigationStyle, horizontalNavPosition}
};
export default withRouter(connect(mapStateToProps)(App));